<template>
  <div class="container">
    <!-- <img
			class="header"
			:src="covers && covers.length > 2 ? covers[2].imgUrl : ''"
		/> -->
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="form-content">
          <div class="title">昵称<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="nickname"
            name="nickname"
            type="text"
            placeholder="请填写您的昵称"
            :rules="[{ required: true, message: '请填写您的昵称' }]"
          />
          <div class="title">联系电话<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="phone"
            name="phone"
            type="tel"
            maxlength="11"
            placeholder="请填写您的联系电话"
            :rules="[{ required: true, message: '请填写您的联系电话' }]"
          />
          <div class="title">请选择版块<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="category"
            name="category"
            is-link
            readonly
            placeholder="点击选择版块"
            @click="showCategoryPicker = true"
            :rules="[{ required: true, message: '请选择版块' }]"
          />
          <van-popup v-model:show="showCategoryPicker" round position="bottom">
            <van-picker
              :columns="categoryColumns"
              @cancel="showCategoryPicker = false"
              @confirm="onCategoryConfirm"
            />
          </van-popup>
          <div class="title">请选择类别<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="channel"
            name="channel"
            is-link
            readonly
            placeholder="点击选择类别"
            @click="showChannelPicker = true"
            :rules="[{ required: true, message: '请选择类别' }]"
          />
          <van-popup v-model:show="showChannelPicker" round position="bottom">
            <van-picker
              :columns="channelColumns"
              @cancel="showChannelPicker = false"
              @confirm="onChannelConfirm"
            />
          </van-popup>

          <div class="title">所在镇街</div>
          <van-field
            class="field"
            v-model="town"
            name="town"
            is-link
            readonly
            placeholder="点击选择镇街"
            @click="showTownPicker = true"
            :rules="[{ required: false, message: '请选择镇街' }]"
          />
          <van-popup v-model:show="showTownPicker" round position="bottom">
            <van-picker
              :columns="townColumns"
              @cancel="showTownPicker = false"
              @confirm="ontownConfirm"
            />
          </van-popup>
          <div class="title">请写下您的内容<span class="star">*</span></div>
          <van-field
            class="field"
            v-model="message"
            name="message"
            required
            rows="6"
            autosize
            type="textarea"
            maxlength="2000"
            placeholder="请写下您的内容"
            show-word-limit
            :rules="[{ required: true, message: '请写下您的内容' }]"
          >
          </van-field>
          <div class="title">相关图片</div>
          <van-field class="fileList-field" name="fileList">
            <template #input>
              <van-uploader
                v-model="fileList"
                multiple
                :max-count="6"
                :max-size="5 * 1024 * 1024"
                @oversize="onOversize"
                :after-read="afterRead"
              />
            </template>
          </van-field>
        </div>
        <div class="btn-div">
          <van-button
            class="submit-btn button glass"
            color="linear-gradient(to right, #f56c42, #feb91f)"
            round
            to="/"
            >返回
          </van-button>
          <van-button
            class="submit-btn button glass"
            type="default"
            round
            color="linear-gradient(to right, #f56c42, #feb91f)"
            native-type="submit"
            :loading="loading"
            loading-text="提交中..."
          >
            提交
          </van-button>
        </div>
      </van-form>
      <!-- <div class="copyright">©2022 中山日报社 版权所有</div> -->
    </div>
  </div>
</template>

<script>
import {
  Popup,
  Picker,
  Dialog,
  Form,
  Field,
  Button,
  Uploader,
  Toast,
} from "vant";
import useFileUpload from "@/composiables/useFileUpload.js";
import { ref, computed } from "vue";
import "@/plugins/bridge.js";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  name: "Home",
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const nickname = ref("");
    if (sessionStorage.getItem("nickName"))
      nickname.value = sessionStorage.getItem("nickName");
    const phone = ref("");
    const message = ref("");
    const fileList = ref([]);

    //--镇街
    const showTownPicker = ref(false);
    const town = ref("");
    const townColumns = [
      "石岐",
      "东区",
      "西区",
      "南区",
      "五桂山",
      "火炬区",
      "民众",
      "南朗",
      "黄圃",
      "南头",
      "东凤",
      "阜沙",
      "小榄",
      "古镇",
      "横栏",
      "三角",
      "港口",
      "大涌",
      "沙溪",
      "三乡",
      "板芙",
      "神湾",
      "坦洲",
      "翠亨新区",
    ];
    const ontownConfirm = (value) => {
      town.value = value;
      showTownPicker.value = false;
    };

    //---版块
    const showCategoryPicker = ref(false);
    const category = ref("");
    const categoryColumns = ["投诉监督", "建言献策"];
    const onCategoryConfirm = (value) => {
      category.value = value;
      showCategoryPicker.value = false;
    };

    //---类别
    const showChannelPicker = ref(false);
    const channel = ref("");
    const channelColumns = [
      "市容市貌",
      "交通秩序",
      "门户环境",
      "道路设施",
      "交叉地带环境",
      "老旧小区背街小巷环境",
      "乱挂乱画乱贴乱建",
      "农贸市场环境",
      "农村人居环境",
    ];
    const onChannelConfirm = (value) => {
      channel.value = value;
      showChannelPicker.value = false;
    };

    const { afterRead } = useFileUpload();

    const onOversize = () => {
      Toast("文件大小不能超过 5mb");
    };

    const loading = ref(false);
    const store = useStore();
    const router = useRouter();
    const onSubmit = (values) => {
      console.log(values);
      loading.value = true;
      //链式处理数据
      store
        .dispatch("submit", values)
        .then((msg) => {
          loading.value = false;
          Dialog.alert({
            message: msg,
          }).then(() => {
            router.replace("/");
          });
        })
        .catch(() => {
          loading.value = false;
        });
    };

    return {
      phone,
      nickname,
      fileList,
      message,
      onOversize,
      afterRead,
      onSubmit,
      loading,
      town,
      townColumns,
      showTownPicker,
      ontownConfirm,
      showCategoryPicker,
      categoryColumns,
      category,
      onCategoryConfirm,
      showChannelPicker,
      channelColumns,
      channel,
      onChannelConfirm,
      covers: computed(() => store.state.covers),
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  background: url("../assets/header.png") no-repeat #f8f8f8;
  background-size: contain;
  // background-color: rgb(69, 141, 196);
}
.header {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
}

.form {
  position: relative;
  padding-top: 40vw;
  margin-left: 20px;
  margin-right: 20px;
  z-index: 3;
  padding-bottom: 80px;
}

.form-content {
  padding: 16px 24px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 30px;
}

.field {
  border-radius: 10px;
  --van-cell-background-color: rgb(245, 247, 250);
  margin-bottom: 20px;
}
.title {
  font-size: 1em;
  margin-left: 2px;
  margin-bottom: 10px;
  .star {
    color: red;
  }
}
.fileList-field {
  --van-cell-horizontal-padding: 0px;
  --van-cell-vertical-padding: 0px;
}
.btn-div {
  display: flex;
  justify-content: space-around;
  margin: 0px 35px;
  position: fixed;
  bottom: 35px;
  z-index: 100;
  right: 0px;
  left: 0px;
}
.submit-btn {
  width: 125px;
  height: 46px;
}
.copyright {
  width: 100%;
  height: 30px;
  margin-top: 20px;
  padding-bottom: 30px;
  text-align: center;
  font-size: 0.8rem;
  color: white;
}
.back-btn {
  position: absolute;
  top: 30px;
  right: 20px;
  height: 27px;
  width: 74px;
  font-weight: 900;
}
</style>
